import { createContext, useContext, useState } from 'react'

import LoginRoute from '../components/login.component'
import ReviewRoute from '../components/review.component'
import PaymentRoute from '../components/payment.component'

const RouterState = createContext()

export const useRouter = () => useContext(RouterState)


export default function RouterProvider(props){
    
    const [state, setState] = useState({
        route: "app",
        routeState: {}
    })
    
    
    const routerState = {
        state,
        methods:{
            changeRoute(name, routeState={}){
                setState(oldState => ({...oldState, route:name, routeState}))
            }
        }
    }
    
    
    
    return (
        <RouterState.Provider value={routerState}>
            {{
                app:props.children,
                login: <LoginRoute />,
                review: <ReviewRoute />,
                payment: <PaymentRoute /> 
            }[state.route]}
        </RouterState.Provider>
    )
}






